import "../key/constants.js";
import { isPhysicalModifier as f } from "../key/guards.js";
import { createKey as u } from "../key/utils.js";
import { IS_MAC as t } from "./constants.js";
import { isShortcutModifier as l, getEventMatchKey as e } from "./shortcut.js";
function p(i) {
  if (!i.code || i.code === "Unidentified" || f(i.code) || i.isComposing || !t && typeof i.getModifierState == "function" && i.getModifierState("AltGraph") || (t ? i.ctrlKey : i.metaKey))
    return null;
  const o = u(i);
  if (l(String(o.id)))
    return null;
  const r = [];
  return (t ? i.metaKey : i.ctrlKey) && r.push("Primary"), i.shiftKey && r.push("Shift"), i.altKey && r.push("Alt"), e(r, String(o.id));
}
export {
  p as buildEventMatchKeyFromEvent
};
